import { useEffect } from 'react';

export const calculateSavings = (
  downtime: number,
  costPerHour: number,
  sevOneDiscount: number,
  setSevOneSavingsOutput: React.Dispatch<React.SetStateAction<number>>,
) => {
  setSevOneSavingsOutput(Number(downtime * costPerHour * sevOneDiscount));
};
